module.exports = __webpack_public_path__ + "static/media/partial.4507a406.svg";